"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnrichDrawerRoutes = exports.ENRICH_DRAWER_SECTION = exports.getEnrichRoutes = void 0;
const router_constants_1 = require("./router.constants");
const feature_flags_1 = require("../feature-flags");
const State = __importStar(require("../store/state"));
const getEnrichRoutes = (featureFlagsService) => ({
    sections: [
        {
            label: 'DASHBOARDS',
            path: router_constants_1.EnrichSection.Dashboards,
            disabled: true,
            routes: [
                {
                    name: 'DASHBOARDS',
                    label: 'DASHBOARDS',
                    path: router_constants_1.EnrichSection.Dashboards,
                    roles: [],
                },
                {
                    name: 'OVERVIEW',
                    label: 'OVERVIEW',
                    path: `${router_constants_1.EnrichSection.Dashboards}/overview`,
                    roles: [],
                },
                {
                    name: 'JOBS',
                    label: 'JOBS',
                    path: `${router_constants_1.EnrichSection.Dashboards}/jobs`,
                    roles: [],
                },
                {
                    name: 'PERFORMANCE',
                    label: 'PERFORMANCE',
                    path: `${router_constants_1.EnrichSection.Dashboards}/performance`,
                    roles: [],
                },
            ],
        },
        {
            label: 'LIBRARIES',
            path: router_constants_1.EnrichSection.Libraries,
            disabled: true,
            routes: [
                {
                    name: 'LIBRARIES',
                    label: 'LIBRARIES',
                    path: router_constants_1.EnrichSection.Libraries,
                    roles: [],
                },
            ],
        },
        {
            label: 'PRODUCT_EDITOR',
            path: router_constants_1.EnrichSection.ProductEditor,
            routes: [
                {
                    name: 'PRODUCT_EDITOR',
                    label: 'PRODUCT_EDITOR',
                    path: router_constants_1.EnrichSection.ProductEditor,
                    roles: [State.UserRole.Admin],
                },
                {
                    name: 'CLASSIFICATION',
                    label: 'CLASSIFICATION',
                    disabled: true,
                    path: `${router_constants_1.EnrichSection.ProductEditor}/classification`,
                    roles: [],
                },
                {
                    name: 'CURATION',
                    label: 'CURATION',
                    disabled: true,
                    path: `${router_constants_1.EnrichSection.ProductEditor}/curation`,
                    roles: [],
                },
                {
                    name: 'VIEWER',
                    label: 'VIEWER',
                    path: `${router_constants_1.EnrichSection.ProductEditor}/viewer`,
                    roles: [State.UserRole.Merchandiser, State.UserRole.Admin],
                },
                {
                    name: 'ENRICH_AI',
                    label: 'ENRICH_AI',
                    path: `${router_constants_1.EnrichSection.EnrichAI}/*`,
                    disabled: !featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.EnrichAI),
                    roles: [State.UserRole.Merchandiser, State.UserRole.Admin, State.UserRole.Unlicensed],
                },
            ],
        },
        {
            label: 'STRATEGY',
            path: router_constants_1.EnrichSection.Strategy,
            disabled: true,
            routes: [
                {
                    name: 'STRATEGY',
                    label: 'STRATEGY',
                    path: router_constants_1.EnrichSection.Strategy,
                    roles: [],
                },
                {
                    name: 'STRATEGY_PREVIEW',
                    label: 'STRATEGY_PREVIEW',
                    path: `${router_constants_1.EnrichSection.Strategy}/preview`,
                    roles: [],
                },
                {
                    name: 'CLASS_VIEW',
                    label: 'CLASS_VIEW',
                    path: `${router_constants_1.EnrichSection.Strategy}/class`,
                    roles: [],
                },
                {
                    name: 'GUIDELINE_VIEW',
                    label: 'GUIDELINE_VIEW',
                    path: `${router_constants_1.EnrichSection.Strategy}/guideline`,
                    roles: [],
                },
            ],
        },
        {
            label: 'CURATION',
            path: router_constants_1.EnrichSection.Curation,
            disabled: true,
            routes: [
                {
                    name: 'CURATION',
                    label: 'CURATION',
                    path: router_constants_1.EnrichSection.Curation,
                    roles: [],
                },
                {
                    name: 'CURATION_RULES',
                    label: 'CURATION_RULES',
                    path: `${router_constants_1.EnrichSection.Curation}/rules`,
                    roles: [],
                },
                {
                    name: 'CURATION_TASKS',
                    label: 'CURATION_TASKS',
                    path: `${router_constants_1.EnrichSection.Curation}/tasks`,
                    roles: [],
                },
            ],
        },
        {
            label: 'MY_WORK',
            path: router_constants_1.EnrichSection.MyWork,
            disabled: true,
            routes: [
                {
                    name: 'MY_WORK',
                    label: 'MY_WORK',
                    path: router_constants_1.EnrichSection.MyWork,
                    roles: [],
                },
            ],
        },
        {
            label: 'NOTIFICATIONS',
            path: router_constants_1.EnrichSection.Notifications,
            disabled: true,
            routes: [
                {
                    name: 'NOTIFICATIONS',
                    label: 'NOTIFICATIONS',
                    path: router_constants_1.EnrichSection.Notifications,
                    roles: [],
                },
            ],
        },
    ],
});
exports.getEnrichRoutes = getEnrichRoutes;
exports.ENRICH_DRAWER_SECTION = {
    path: router_constants_1.ENRICH,
    label: 'ENRICH',
    plugin: true,
    hasLazyLoadedRoutes: true,
    categories: [],
};
const getEnrichDrawerRoutes = () => ({
    editor: {
        name: 'PRODUCT_EDITOR',
        label: 'PRODUCT_EDITOR',
        path: `/${router_constants_1.ENRICH}/${router_constants_1.EnrichSection.ProductEditor}`,
        roles: [],
        isDynamicRoute: true,
    },
    viewer: {
        name: 'VIEWER',
        label: 'VIEWER',
        path: `/${router_constants_1.ENRICH}/${router_constants_1.EnrichSection.ProductEditor}/viewer`,
        roles: [],
        isDynamicRoute: true,
    },
    ai: {
        name: 'ENRICH_AI',
        label: 'ENRICH_AI',
        path: `/${router_constants_1.ENRICH}/${router_constants_1.EnrichSection.EnrichAI}`,
        roles: [],
        isDynamicRoute: true,
    },
});
exports.getEnrichDrawerRoutes = getEnrichDrawerRoutes;
